module.exports = __webpack_public_path__ + "images/backgrounds/city/medium.a7eea5e35c08388ec3da.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/city/medium.jpg
// module id = bicS
// module chunks = 2